<script setup lang="ts">
const props = defineProps<{ data: StatsProps; template?: 'page' | 'overlay' }>()
const { $gsap, $ScrollTrigger } = useNuxtApp()
const bigNumber = computed(() => props.data.bigNumbers)

function initAnimation() {
  const counters = document.querySelectorAll('[data-counter]')
  if (!counters.length) return
  counters.forEach((el) => {
    const rawText = el.getAttribute('data-counter') || ''
    const match = rawText.match(/([\d,.]+)/)
    if (!match) return

    const numberPart = match[1]
    const number = parseFloat(numberPart.replace(/,/g, ''))
    const parts = rawText.split(numberPart)
    const prefix = parts[0] || ''
    const suffix = parts[1] || ''

    // Initialize content with 0
    el.innerHTML = `${prefix}<span class="counter">0</span>${suffix}`
    const counterEl = el.querySelector('.counter')
    if (!counterEl) return

    const obj = { val: 0 }
    $gsap.to(obj, {
      val: number,
      duration: 2,
      ease: 'power2.inOut',
      scrollTrigger: {
        id: 'stats',
        trigger: el,
        scroller: document.querySelector('#overlay') ?? null,
        start: 'top 80%',
        end: 'bottom 80%',
        // markers: true,
        toggleActions: 'play none none none', // only run once
      },
      onUpdate: () => {
        counterEl.innerText = Math.round(obj.val).toLocaleString()
      },
    })
  })
}

onMounted(async () => {
  await nextTick()
  await cleanupAnimation()
  initAnimation()
})

async function cleanupAnimation(): Promise<void> {
  $ScrollTrigger.getById('stats')?.kill()
  await Promise.resolve()
}

onBeforeUnmount(async () => {
  await cleanupAnimation()
})
</script>
<template>
  <section
    class="px-bleed py-4 lg:py-5"
    :class="{
      'bg-white': template !== 'page' && template !== 'overlay' && data.theme !== 'light-grey',
      'bg-light-grey':
        template === 'page' || (template !== 'overlay' && data.theme === 'light-grey'),
    }"
  >
    <ul class="gap-x-gap grid grid-cols-2 gap-y-10 lg:grid-cols-4">
      <li v-for="(stat, idx) in data.stats" :key="idx" class="flex flex-col gap-3">
        <p
          v-dompurify-html="stat.title"
          class="font-display uppercase font-stretch-expanded"
          :class="bigNumber ? 'text-3xl lg:text-5xl' : 'text-3xl lg:text-4xl'"
          :data-counter="stat.title"
        />
        <p class="font-mono text-sm uppercase">{{ stat.text }}</p>
      </li>
    </ul>
  </section>
</template>
